<template>
  <authenticated-layout class="">
    <page-header
      :title="$t('components.DashboardPage.title')"
      description="Monitor your institution's progress and performance"
    />

    <v-container class="mt-0 mx-auto pa-0 border-b" fluid>
      <v-tabs v-model="activeTab" grow>
        <v-tab value="adoption">
          Adoption
        </v-tab>
        <v-tab value="usage">
          Usage
        </v-tab>
      </v-tabs>
    </v-container>

    <div class="mt-2">
      <v-container class="mx-auto" fluid>
        <v-tabs-window v-model="activeTab">
          <v-tabs-window-item value="adoption">
            <AdoptionStatsDashboard />
          </v-tabs-window-item>
          <v-tabs-window-item value="usage">
            <UsageStatsDashboard />
          </v-tabs-window-item>
        </v-tabs-window>
      </v-container>
    </div>

  </authenticated-layout>
</template>

<script setup lang="ts">
import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import PageHeader from "@/components/PageHeader.vue";
import {ref} from "vue";
import UsageStatsDashboard from "@/pages/DashboardPage/UsageStatsDashboard.vue";
import AdoptionStatsDashboard from "@/pages/DashboardPage/AdoptionStatsDashboard.vue";

const activeTab = ref("adoption");

</script>
